/**
 * 메뉴 식별자(menu_code) 상수.
 * 백엔드 CRM.Domain/Constants/MenuCodes.cs 와 반드시 동기화할 것.
 *
 * 기존의 menuId 매직넘버(21, 31, 61 …) 하드코딩을 대체한다.
 * 고객사별로 메뉴를 커스터마이즈해도 코드는 불변이므로 라우트가 깨지지 않는다.
 */
export const MENU = {
  // 모듈(GNB)
  MODULE_HOME: 'HOME',
  MODULE_CRM: 'CRM',
  MODULE_PROJECT: 'PROJECT',
  MODULE_INVENTORY: 'INVENTORY',
  MODULE_BOARD: 'BOARD',
  MODULE_SETTINGS: 'SETTINGS',
  // 확장 예정
  MODULE_APPROVAL: 'APPROVAL',
  MODULE_RESOURCE: 'RESOURCE',
  MODULE_HR: 'HR',
  MODULE_SCHEDULE: 'SCHEDULE',

  // 대시보드
  HOME_DASHBOARD: 'HOME_DASHBOARD',

  // 고객/영업
  CRM_CUSTOMER_STATUS: 'CRM_CUSTOMER_STATUS',
  CRM_CUSTOMER: 'CRM_CUSTOMER',
  CRM_CUSTOMER_EMPLOYEE: 'CRM_CUSTOMER_EMPLOYEE',
  CRM_SALES_ACTIVITY: 'CRM_SALES_ACTIVITY',
  CRM_OPPORTUNITY: 'CRM_OPPORTUNITY',
  CRM_SALES_REPORT: 'CRM_SALES_REPORT',

  // 프로젝트
  PRJ_LIST: 'PRJ_LIST',
  PRJ_TASK: 'PRJ_TASK',
  PRJ_CALENDAR: 'PRJ_CALENDAR',
  PRJ_FILE: 'PRJ_FILE',
  PRJ_ROADMAP: 'PRJ_ROADMAP',
  PRJ_GANTT: 'PRJ_GANTT',
  PRJ_COST: 'PRJ_COST',
  PRJ_REPORT: 'PRJ_REPORT',

  // 재고
  INV_ITEM: 'INV_ITEM',
  INV_INOUT: 'INV_INOUT',
  INV_STOCK: 'INV_STOCK',
  INV_MONTHLY_CLOSING: 'INV_MONTHLY_CLOSING',
  INV_LOCATION: 'INV_LOCATION',
  INV_COUNT: 'INV_COUNT',
  INV_RENTAL: 'INV_RENTAL',

  // 게시판
  BOARD_NOTICE: 'BOARD_NOTICE',
  BOARD_ARCHIVE: 'BOARD_ARCHIVE',

  // 전자결재
  APPR_DRAFT: 'APPR_DRAFT',
  APPR_BOX: 'APPR_BOX',
  APPR_INBOX: 'APPR_INBOX',
  APPR_PROGRESS: 'APPR_PROGRESS',
  APPR_COMPLETED: 'APPR_COMPLETED',
  APPR_REJECTED: 'APPR_REJECTED',
  APPR_DRAFTED: 'APPR_DRAFTED',
  APPR_REFERENCE: 'APPR_REFERENCE',
  APPR_SEARCH: 'APPR_SEARCH',
  APPR_FORM: 'APPR_FORM',
  APPR_RULE: 'APPR_RULE',
  APPR_DELEGATION: 'APPR_DELEGATION',

  // 인사관리
  HR_EMPLOYEE: 'HR_EMPLOYEE',
  HR_ORGCHART: 'HR_ORGCHART',
  HR_WORK_PARTICIPATION: 'HR_WORK_PARTICIPATION',
  HR_LEAVE_STATUS: 'HR_LEAVE_STATUS',
  HR_LEAVE_POLICY: 'HR_LEAVE_POLICY',

  // 자원관리
  RES_RESERVATION: 'RES_RESERVATION',
  RES_USAGE: 'RES_USAGE',
  RES_ASSET: 'RES_ASSET',

  // 일정·메모관리
  SCH_PERSONAL: 'SCH_PERSONAL',
  SCH_DEPARTMENT: 'SCH_DEPARTMENT',
  SCH_COMPANY: 'SCH_COMPANY',

  // 설정
  SET_COMMON_CODE: 'SET_COMMON_CODE',
  SET_USER: 'SET_USER',
  SET_PERMISSION: 'SET_PERMISSION',
  SET_COMPANY: 'SET_COMPANY',
  SET_LOG: 'SET_LOG',
  SET_ORGANIZATION: 'SET_ORGANIZATION',
};

/** 사이드바 배지(숫자) 키 — 백엔드 BadgeKeys 와 동기화 */
export const BADGE = {
  APPROVAL_PENDING: 'APPR_PENDING',
  NOTIFICATION_UNREAD: 'NOTI_UNREAD',
  TASK_ASSIGNED: 'TASK_ASSIGNED',
};

/**
 * 모바일 하단 탭바 구성.
 * - menuCode 가 지정된 탭은 해당 메뉴에 접근 권한이 있을 때만 노출된다.
 *   → 전자결재 모듈을 추가하면 이 파일을 수정하지 않아도 '결재' 탭이 자동으로 나타난다.
 * - action: 'drawer' 는 전체 메뉴 서랍을 연다.
 */
export const MOBILE_TABS = [
  { key: 'home', label: '홈', icon: 'Home', to: '/dashboard' },
  { key: 'approval', label: '결재', icon: 'FileSignature', menuCode: 'APPR_INBOX', badgeKey: BADGE.APPROVAL_PENDING },
  { key: 'task', label: '업무', icon: 'ListTodo', menuCode: MENU.PRJ_TASK },
  { key: 'noti', label: '알림', icon: 'Bell', to: '/notifications', badgeKey: BADGE.NOTIFICATION_UNREAD },
  { key: 'all', label: '전체', icon: 'LayoutGrid', action: 'drawer' },
];

export default MENU;
